import { loadStripe } from "@stripe/stripe-js/pure";
import { gql, useLazyQuery, useQuery } from "@apollo/client";
import React, { useState } from "react";
import Tabs from "../../Tabs";
import "./register.css";
import SubscriptionOptions from "./SubscriptionOptions";
import { useHistory } from "react-router-dom";
import TwitterTestimonials from "./TwitterTestimonials";

const GET_CHECKOUT_SESSION = gql`
  query GetCheckoutPortal($priceId: String!) {
    checkoutPortal(priceId: $priceId) {
      id
    }
  }
`;

const GET_PRODUCTS = gql`
  query {
    products {
      id
      name
      prices {
        id
        recurring {
          interval
        }
        unitAmount
        unitAmountDecimal
      }
    }
  }
`;

export default function Memberships() {
  const history = useHistory();

  const { loading, error, data } = useQuery(GET_PRODUCTS);
  const [priceId, setPriceId] = useState("");

  if (loading) return <></>;
  if (error) return "Error.";

  function handleSignUpClick(event) {
    const selectedPriceId = event.target.name;

    setPriceId(selectedPriceId);

    history.push("/memberships/register/" + selectedPriceId);
  }

  const products = data.products;

  return (
    <div id="register-container">
      <h1 className="register-header">Memberships</h1>
      <div className="register-byline">
        <p>
          Gup’s Corner is more than a website for DFS, Betting and contest
          strategy information -- we are the premier community in this industry
          and, without a doubt, the best value in the market. Become a valued
          member today!
        </p>
      </div>
      <Tabs>
        {products.map((product) => {
          return (
            <SubscriptionOptions
              label={product.name}
              key={product.name}
              prices={product.prices}
              onClick={handleSignUpClick}
            />
          );
        })}
      </Tabs>
      <TwitterTestimonials />
    </div>
  );
}
